var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarming = function SvgWarming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    fillRule: "evenodd",
    d: "M1.333 6a4.667 4.667 0 1 0 9.334 0 4.667 4.667 0 0 0-9.334 0ZM6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0Zm0 2.667c.368 0 .667.298.667.666v3.334a.667.667 0 0 1-1.334 0V3.333c0-.368.299-.666.667-.666Zm0 6.666A.667.667 0 1 0 6 8a.667.667 0 0 0 0 1.333Z",
    clipRule: "evenodd"
  })));
};
export default SvgWarming;